<!-- 订单类型 -->
<template>
  <BaseFormItem
    class="order_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isShowLabelTitle="false"
    isShowRequiredIcon
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <div slot="labelTipsContent" class="is_first_confirm__labelTipsContent">
      <a href="javascript:void(0)" @click="dialogVisible = true" class="rule-link">研发型订单规则详情</a>
    </div>      
    <BaseRadioGroup v-model="val.is_develop_order" @change="handleChange">
      <template v-for="item in fields.options">
        <BaseTipPopover
          v-if="item.value === 1"
          :key="item.value"
          placement="top"
          width="400px"
        >
          <div class="radio-button-wrapper" slot="reference">
            <el-radio-button
              :label="item.value"
              :disabled="isDevelopOrderDisabled"
            >{{ item.label }}</el-radio-button>
            <span class="discount-badge">特惠</span>
          </div>
          <p >研发型订单每日限 100 单，当日额度用尽后仅可提交标准型订单；<br/>若研发型选项呈置灰状态，代表当前所选参数不支持研发型订单，请查看</p>
        </BaseTipPopover>
        <el-radio-button
          v-else
          :key="item.value"
          :label="item.value"
        >{{ item.label }}</el-radio-button>
      </template>
    </BaseRadioGroup>
    <div class="order_type__rules" @click="dialogVisible = true">
      规则说明
    </div>
    <div v-if="isDevelopOrderDisabled && getUnmetItemCount() > 0" class="order_type__badge" @click="dialogVisible = true">
      <img class="badge-icon" src="@@/assets/img/smt/order_type/warning-white.png" />
      {{ getUnmetItemCount() }}项不满足
    </div>
    <div v-if="Number(val.is_develop_order) === 1 && getUnmetItemCount() == 0" class="order_type__tips" >
      如需调整以下参数，请改为标准型
    </div>
    
    <OrderRuleDialog v-model="dialogVisible" :developOrderSupport="developOrderSupport"/>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'
import OrderRuleDialog from '@@/components/OrderRuleDialog/index.vue'
import { checkDevelopOrderLimit } from '@@/api/pcba.js'

export default {
  components: {
    OrderRuleDialog
  },
  props: {
    // 订单类型：0-标准型 1-研发型
    is_develop_order: {
      type: [Number, String],
      default: 0
    },
    // PCB选项：1-在华秋定制 2-已在华秋下单 3-自己提供
    custom_pcb_ban: {
      type: [Number, String],
      default: 1
    },
    // PCB层数
    pcbLayers: {
      type: [Number, String],
      default: ''
    },
    // 板厚
    boardThickness: {
      type: [Number, String],
      default: ''
    },
    // 物料种类
    bom_material_type_number: {
      type: [Number, String],
      default: ''
    },
    // 样品图确认：0-不需要 1-需要
    is_first_confirm: {
      type: [Number, String],
      default: ''
    },
    // BOM来料方式：4-自助匹配选型 1-华秋帮我选型 2-自己提供
    buy_bom: {
      type: [Number, String],
      default: 4
    },
    // 生产数量
    number: {
      type: [Number, String],
      default: ''
    },
    // 单片数量
    bcount: {
      type: [Number, String],
      default: ''
    },
    // 单片尺寸
    pcbSize: {
      type: Object,
      default: () => ({ width: 0, length: 0 })
    },
    // 钢网类型：0-普通钢网 1-阶梯钢网
    steel_type: {
      type: [Number, String],
      default: 0
    },
    // 三防漆：0-不需要 其他-需要
    need_conformal_coating: {
      type: [Number, String],
      default: 0
    },
    // 特殊工艺
    is_assembly_weld: {
      type: [Number, String],
      default: 0
    },
    is_assemble: {
      type: [Number, String],
      default: 0
    },
    need_split: {
      type: [Number, String],
      default: 0
    },
    is_layout_cleaning: {
      type: [Number, String],
      default: 0
    },
    is_welding_wire: {
      type: [Number, String],
      default: 0
    },
    is_increase_tinning: {
      type: [Number, String],
      default: 0
    },
    is_test: {
      type: [Number, String],
      default: 0
    },
    is_program_burning: {
      type: [Number, String],
      default: 0
    },
    // 工艺备注
    postscript: {
      type: String,
      default: ''
    },
    // 工艺备注附件地址
    file_postscript: {
      type: String,
      default: ''
    },
    // 工艺备注附件名称
    file_postscript_name: {
      type: String,
      default: ''
    },
    // 出货形式：1-单片 2-连片
    units: {
      type: [Number, String],
      default: 1
    },
    // 拼板列数
    layoutx: {
      type: [Number, String],
      default: 1
    },
    // 拼板行数
    layouty: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      val: {
        is_develop_order: this.is_develop_order
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      dialogVisible: false,
      isDevelopOrderDisabled: false, // 研发型是否被禁用
      developOrderSupport: {}, // 研发型订单支持度判断结果
      canDevelopOrder: true, // 是否可以提交研发型订单（接口返回）
    }
  },
  computed: {
    fields() {
      return getSMTFields('is_develop_order')
    }
  },
  mounted() {
    // 页面初始化时检查研发型订单状态
    this.checkDevelopOrderStatus()
    // 初始化请求研发型订单限制接口
    this.fetchDevelopOrderLimit()
  },
  watch: {
    is_develop_order(newVal) {
      this.val.is_develop_order = newVal
    },
    // 监听所有相关字段的变化
    custom_pcb_ban: 'checkDevelopOrderStatus',
    pcbLayers: 'checkDevelopOrderStatus',
    boardThickness: 'checkDevelopOrderStatus',
    buy_bom: 'checkDevelopOrderStatus',
    bom_material_type_number: 'checkDevelopOrderStatus',
    is_first_confirm: 'checkDevelopOrderStatus',
    number: 'checkDevelopOrderStatus',
    bcount: 'checkDevelopOrderStatus',
    pcbSize: {
      handler: 'checkDevelopOrderStatus',
      deep: true
    },
    steel_type: 'checkDevelopOrderStatus',
    need_conformal_coating: 'checkDevelopOrderStatus',
    is_assembly_weld: 'checkDevelopOrderStatus',
    is_assemble: 'checkDevelopOrderStatus',
    need_split: 'checkDevelopOrderStatus',
    is_layout_cleaning: 'checkDevelopOrderStatus',
    is_welding_wire: 'checkDevelopOrderStatus',
    is_increase_tinning: 'checkDevelopOrderStatus',
    is_test: 'checkDevelopOrderStatus',
    is_program_burning: 'checkDevelopOrderStatus',
    postscript: 'checkDevelopOrderStatus',
    file_postscript: 'checkDevelopOrderStatus',
    file_postscript_name: 'checkDevelopOrderStatus',
    units: 'checkDevelopOrderStatus',
    layoutx: 'checkDevelopOrderStatus',
    layouty: 'checkDevelopOrderStatus'
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleChange() {
      // 如果尝试选择研发型，再次检查是否允许
      if (Number(this.val.is_develop_order) === 1) {
        const shouldDisable = this.checkShouldForceStandard()
        if (shouldDisable) {
          // 不允许选择研发型，切换回标准型
          this.val.is_develop_order = 0
          this.$nextTick(() => {
            this.handleEmit('is_develop_order')
          })
          return
        }
      }
      this.handleEmit('is_develop_order')
    },
    // 检查研发型订单状态（用于 watch 监听）
    checkDevelopOrderStatus() {
      const shouldDisable = this.checkShouldForceStandard()
      this.isDevelopOrderDisabled = shouldDisable
      
      // 如果当前是研发型且被禁用，自动切换回标准型
      if (shouldDisable && Number(this.val.is_develop_order) === 1) {
        this.val.is_develop_order = 0
        this.$nextTick(() => {
          this.handleEmit('is_develop_order')
        })
      }
    },
    // 检查是否应该强制切换回标准型
    checkShouldForceStandard() {
      const { 
        custom_pcb_ban, 
        pcbLayers, 
        boardThickness,
        buy_bom,
        bom_material_type_number,
        is_first_confirm,
        number,
        bcount,
        units,
        layoutx,
        layouty,
        pcbSize,
        steel_type,
        need_conformal_coating,
        is_assembly_weld,
        is_assemble,
        need_split,
        is_layout_cleaning,
        is_welding_wire,
        is_increase_tinning,
        is_test,
        is_program_burning,
        postscript,
        file_postscript,
        file_postscript_name
      } = this

      // 1. PCB选项为【已在华秋下单】【自己下单】
      const isCustomPcbBan = [2, 3].includes(Number(custom_pcb_ban))
      
      // 2. 板子层数不为2和4
      const layerNum = Number(pcbLayers)
      const isLayerNotValid = isNaN(layerNum) || layerNum === 0 || (layerNum !== 2 && layerNum !== 4)
      
      // 3. 板子厚度不为1.6
      const thickness = Number(boardThickness)
      const isThicknessNotValid = isNaN(thickness) || thickness === 0 || thickness !== 1.6
      
      // 4. BOM选择【华秋帮我选型】【自己提供】
      const isBuyBomNotAuto = [1, 2].includes(Number(buy_bom))
      
      // 5. 物料种类大于60
      const bomNum = Number(bom_material_type_number)
      const isBomExceed = !isNaN(bomNum) && bomNum >= 60
      
      // 6. 样品图确认为需要
      const isFirstConfirmNeeded = is_first_confirm !== '' && is_first_confirm !== undefined && Number(is_first_confirm) === 1
      
      // 7. 生产数量和单片数量必须一致，且都为5或10
      const num = Number(number)
      const bcountNum = Number(bcount)
      const unitsNum = Number(units)
      const layoutxNum = Number(layoutx) || 1
      const layoutyNum = Number(layouty) || 1
      
      // 单片实际数量计算规则：
      // units=1 (单片出货): actualBcount = bcount
      // units=2 (华秋代拼): actualBcount = bcount × layoutx × layouty
      // units=3 (按客供要求): actualBcount = bcount × layoutx × layouty
      const actualBcount = unitsNum === 1 ? bcountNum : bcountNum * layoutxNum * layoutyNum
      
      // 生产数量和单片数量都必须是5或10，且两者必须相等
      const isNumberNotValid = !isNaN(num) && num > 0 && num !== 5 && num !== 10
      const isBcountNotValid = !isNaN(actualBcount) && actualBcount > 0 && actualBcount !== 5 && actualBcount !== 10
      const isNumberNotEqualBcount = !isNaN(num) && !isNaN(actualBcount) && num > 0 && actualBcount > 0 && num !== actualBcount
      
      // 9. 单片尺寸范围：长 5-22cm 且 宽 5-15cm（pcbSize 已经包含工艺边，直接使用计算后的值判断）
      // 注意：pcbSize.width 是宽，pcbSize.length 是长
      // 研发型要求：长>=5cm 且 长<=22cm 且 宽>=5cm 且 宽<=15cm
      const width = Number(pcbSize?.width)   // 宽
      const length = Number(pcbSize?.length) // 长
      const isSizeNotValid = (!isNaN(width) && !isNaN(length) && width > 0 && length > 0) && (length < 5 || length > 22 || width < 5 || width > 15)
      
      // 10. 钢网为阶梯钢网（研发型不支持阶梯钢网）
      const isSteelNotLadder = Number(steel_type) === 1
      
      // 11. 三防漆不为不需要（只有当有值时才判断）
      const isConformalCoatingNeeded = need_conformal_coating !== '' && need_conformal_coating !== undefined && Number(need_conformal_coating) !== 0
      
      // 12. 特殊工艺只能勾选物料烘烤
      const specialProcesses = [
        Number(is_assembly_weld),
        Number(is_assemble),
        Number(need_split),
        Number(is_layout_cleaning),
        Number(is_welding_wire),
        Number(is_increase_tinning),
        Number(is_test),
        Number(is_program_burning)
      ]
      const hasInvalidSpecialProcess = specialProcesses.some(val => val === 1)
      // 允许的特殊工艺：仅物料烘烤(is_material_baking)
      // 如果其他特殊工艺有被勾选的，则不符合研发型条件

      // 13. 研发型订单不能有工艺备注
      const hasPostscript = !!(postscript && typeof postscript === 'string' && postscript.trim() !== '')
      
      // 14. 研发型订单不能有工艺备注文件上传
      const hasPostscriptFile = !!((file_postscript && typeof file_postscript === 'string' && file_postscript.trim() !== '') || 
                                (file_postscript_name && typeof file_postscript_name === 'string' && file_postscript_name.trim() !== '')) 
      
      // 研发型订单支持度判断
      this.developOrderSupport = {
        orderType: !isCustomPcbBan && !isBuyBomNotAuto,  // PCB在华秋定制 + BOM自助匹配选型
        pcbSize: !isSizeNotValid,  // 宽5-15cm, 长5-22cm
        pcbLayers: !isLayerNotValid,  // 仅限2层或4层
        quantity: !isNumberNotValid && !isBcountNotValid && !isNumberNotEqualBcount,  // 5片或10片, 且生产数量=单片数量
        boardThickness: !isThicknessNotValid,  // 1.6mm板厚
        bomMaterial: !isBomExceed,  // ≤60种
        specialProcess: !hasInvalidSpecialProcess && !isConformalCoatingNeeded && !isSteelNotLadder,  // 不支持特殊工艺/三防漆/阶梯钢网
        sampleConfirm: !isFirstConfirmNeeded,  // 不支持样品图确认
        postscript: !hasPostscript && !hasPostscriptFile  // 不支持工艺备注及附件
      }

      // 只要满足任意一个条件，就不符合研发型订单要求
      return (
        !this.canDevelopOrder ||  // 接口返回不允许研发型订单
        isCustomPcbBan ||
        isLayerNotValid ||
        isThicknessNotValid ||
        isBuyBomNotAuto ||
        isBomExceed ||
        isFirstConfirmNeeded ||
        isNumberNotValid ||
        isBcountNotValid ||
        isNumberNotEqualBcount ||
        isSizeNotValid ||
        isSteelNotLadder ||
        isConformalCoatingNeeded ||
        hasInvalidSpecialProcess ||
        hasPostscript ||
        hasPostscriptFile
      )
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
    // 计算不满足研发型订单要求的项数
    getUnmetItemCount() {
      let count = 0
      const support = this.developOrderSupport
      
      // developOrderSupport 中为 false 的项表示不满足
      if (!support.orderType) count++
      if (!support.pcbSize) count++
      if (!support.pcbLayers) count++
      if (!support.quantity) count++
      if (!support.boardThickness) count++
      if (!support.bomMaterial) count++
      if (!support.specialProcess) count++
      if (!support.sampleConfirm) count++
      if (!support.postscript) count++
      
      return count
    },
    // 请求研发型订单限制接口
    async fetchDevelopOrderLimit() {
      try {
        const res = await checkDevelopOrderLimit()
        console.log('checkDevelopOrderLimit 返回内容:', res)
        
        // 保存接口返回的限制信息
        if (res.result) {
          this.canDevelopOrder = res.result.canDevelopOrder !== false
        }
        
        // 重新检查研发型订单状态
        this.checkDevelopOrderStatus()
      } catch (error) {
        console.error('checkDevelopOrderLimit 请求失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order_type__rules {
  display: inline-block;
  color: #15A675;
  margin-left: 15px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}
.order_type__tips {
  display: inline-block;
  margin-left: 15px;
  font-size: 12px;
  color: $--color-warning;
}

.order_type__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  background-color: #FF1B1B;
  border-radius: 10px;
  color: #ffffff;
  font-size: 12px;
  margin-left: 8px;
  vertical-align: middle;
  cursor: pointer;

  .badge-icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}

.rule-link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  
  &::after {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-left: 4px;
    border-right: 1.5px solid currentColor;
    border-bottom: 1.5px solid currentColor;
    transform: rotate(-45deg);
    transition: border-color 0.2s ease;
    vertical-align: middle;
  }
  
  &:hover {
    color: #0070CC;
  }
}

.radio-button-wrapper {
  position: relative;
  display: inline-block;
}

.discount-badge {
  position: absolute;
  top: -8px;
  right: 0;
  color: white;
  font-size: 12px;
  width: 32px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #ff4d4f;
  border-radius: 3px;
  z-index: 10;
}
</style>
